.dropdown {
  width: max-content;
  min-width: var(--combobox-target-width, 150px);
  max-height: 300px;
  overflow-y: auto;
}

.option {
  flex-wrap: nowrap;
  white-space: nowrap;
}

.optionLabel {
  white-space: nowrap;
}

.checkIcon {
  flex-shrink: 0;
}
